export const CLUSTER_PAGE_MESSAGES = {
  PRIVATE_CLUSTER:
    "The control plane of this cluster is not accessible through the internet. Private control planes are currently not supported.",
  DELETED_CLUSTER:
    "This cluster has been deleted. If you think this is an error, please contact support or check the connection configuration.",
};
